import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

export const TooltipDefault = ({ children, text, placement = 'top' }) => {
  return (
    <Tooltip title={text} color={'#108ee9'} placement={placement}>
      {children}
    </Tooltip>
  );
};

TooltipDefault.propTypes = {
  children: PropTypes.element,
};

TooltipDefault.defaultProps = {
  // children: null,
  // text: '',
};

export default TooltipDefault;
